module.exports = __webpack_public_path__ + "img/font.d7ee9adb.png";